








































import Vue, { PropType } from "vue";
import fetch from "cross-fetch";

export interface PaypalCustomCardFieldsData {
  isProcessing: boolean;
  isActive: boolean;
}

export interface GoldPurchasePaypalDeleteCardInformationDialogProps {
  deleteApiUrl: string;
  returnUrl: string;
  errorUrl: string;
  csrfToken: string;
  updateIsBusy: any;
  translationResources: object;
}

export default Vue.extend({
  name: "vc-gold-purchase-paypal-delete-card-information-dialog",
  props: {
    deleteApiUrl: {
      type: String as PropType<
        GoldPurchasePaypalDeleteCardInformationDialogProps["deleteApiUrl"]
      >,
      default: ""
    },
    returnUrl: {
      type: String as PropType<
        GoldPurchasePaypalDeleteCardInformationDialogProps["returnUrl"]
      >,
      default: ""
    },
    errorUrl: {
      type: String as PropType<
        GoldPurchasePaypalDeleteCardInformationDialogProps["errorUrl"]
      >,
      default: ""
    },
    csrfToken: {
      type: String as PropType<
        GoldPurchasePaypalDeleteCardInformationDialogProps["csrfToken"]
      >,
      default: ""
    },
    //mutationsToProps
    updateIsBusy: {
      type: Function as PropType<
        GoldPurchasePaypalDeleteCardInformationDialogProps["updateIsBusy"]
      >,
      default: () => {}
    },
    translationResources: {
      type: Object as PropType<
        GoldPurchasePaypalDeleteCardInformationDialogProps["translationResources"]
      >,
      default: () => {}
    }
  },
  data(): PaypalCustomCardFieldsData {
    return {
      isProcessing: false,
      isActive: false
    };
  },
  computed: {},
  methods: {
    openDialog() {
      this.isActive = true;
    },
    closeDialog() {
      this.isActive = false;
    },
    deleteAction(event: object) {
      this.isProcessing = true;
      this.updateIsBusy(true);
      this.deleteCardInfo(event);
    },
    deleteCardInfo(event: any) {
      fetch(this.deleteApiUrl, {
        method: "DELETE",
        headers: {
          "x-csrf-token": this.csrfToken
        }
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          this.closeDialog();
          this.$emit("catch-is-deleted");
          this.isProcessing = false;
          this.updateIsBusy(false);
        })
        .catch(error => {
          location.href = this.errorUrl + "?type=system_error";
          this.isProcessing = false;
          this.updateIsBusy(false);
        });
    }
  }
});
